import loadable from '@loadable/component';

const Landing = loadable(() =>
  import('app/features/landing/components/Landing'),
);
const Components = loadable(() => import('test/Components'));
const Success = loadable(() =>
  import('app/features/success/components/Success'),
);
const Billing = loadable(() =>
  import('app/features/billing/components/Billing/Billing'),
);
const Login = loadable(() =>
  import('app/features/authentication/components/Login/Login'),
);
const Register = loadable(() =>
  import('app/features/authentication/components/Register/Register'),
);
const RegistrationPromo = loadable(() =>
  import('app/features/registrationPromo'),
);
const PricingPromoLanding = loadable(() =>
  import('app/features/pricingPromo/landing'),
);
const PricingPromoSuccess = loadable(() =>
  import('app/features/pricingPromo/success'),
);
const MigrationLanding = loadable(() =>
  import('app/features/migration/landing'),
);
const MigrationSuccess = loadable(() =>
  import('app/features/migration/success'),
);
const CouponSuccess = loadable(() =>
  import('app/features/couponCampaign/success'),
);
const AlreadyPremium = loadable(() =>
  import('app/features/alreadyPremium/AlreadyPremium'),
);
const ErrorPage = loadable(() => import('app/components/errorPages/Error'));
const OfferUnavailable = loadable(() =>
  import('app/components/errorPages/OfferUnavailable'),
);

Landing.displayName = 'Landing';
Components.displayName = 'Components';
Success.displayName = 'Success';
Billing.displayName = 'Billing';
Login.displayName = 'Login';
Register.displayName = 'Register';
RegistrationPromo.displayName = 'RegistrationPromo';
PricingPromoLanding.displayName = 'PricingPromoLanding';
PricingPromoSuccess.displayName = 'PricingPromoSuccess';
MigrationLanding.displayName = 'MigrationLanding';
MigrationSuccess.displayName = 'MigrationSuccess';
CouponSuccess.displayName = 'CouponSuccess';
AlreadyPremium.displayName = 'AlreadyPremium';
ErrorPage.displayName = 'ErrorPage';
OfferUnavailable.displayName = 'OfferUnavailable';

export {
  Landing,
  Components,
  Success,
  Billing,
  Login,
  ErrorPage,
  OfferUnavailable,
  Register,
  AlreadyPremium,
  RegistrationPromo,
  PricingPromoLanding,
  PricingPromoSuccess,
  MigrationLanding,
  MigrationSuccess,
  CouponSuccess,
};
